module.exports = __webpack_public_path__ + "img/organization-panel.aec4813c.png";